import * as React from "react";
import {
    List, Datagrid, TextField, EditButton, Edit, Create,
    SimpleForm, TextInput, SelectInput, DateField, DateInput,
    NumberField, BooleanInput, Filter, SelectField, BooleanField,
    required
} from 'react-admin';
import RichTextInputInput from 'ra-input-rich-text';
import { UpLoadFile } from '../components/custom/UpLoadFile';

const Categories = [
    { id: '种植技术', name: '种植技术' },
    { id: '养殖技术', name: '养殖技术' },
    { id: '水产技术', name: '水产技术' },
    { id: '农机技术', name: '农机技术' },
    { id: '土壤肥料', name: '土壤肥料' },
    { id: '植物保护', name: '植物保护' },
    { id: '农业政策', name: '农业政策' },
    { id: '市场信息', name: '市场信息' },
];

const StatusChoices = [
    { id: 0, name: '草稿' },
    { id: 1, name: '已发布' },
];

const ArticleFilter = props => (
    <Filter {...props}>
        <TextInput source="key" label="搜索" alwaysOn />
        <SelectInput source="category" label="分类" choices={Categories} alwaysOn />
        <SelectInput source="status" label="状态" choices={StatusChoices} />
    </Filter>
);

export const AgriTechArticleList = props => (
    <List {...props} filters={<ArticleFilter />} title="农技推广">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Title" label="标题" />
            <SelectField source="Category" label="分类" choices={Categories} />
            <SelectField source="Status" label="状态" choices={StatusChoices} />
            <NumberField source="ViewCount" label="浏览量" />
            <BooleanField source="IsFeatured" label="推荐" />
            <DateField source="CreateTime" label="创建时间" showTime />
            <DateField source="PublishTime" label="发布时间" showTime />
            <EditButton />
        </Datagrid>
    </List>
);

export const AgriTechArticleEdit = props => (
    <Edit {...props} title="编辑农技文章">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Title" label="标题" validate={required()} />
            <RichTextInputInput source="Content" label="内容" />
            <UpLoadFile source="CoverImage" label="封面图片" />
            <TextInput source="Summary" label="摘要" multiline rows={3} />
            <SelectInput source="Category" label="分类" choices={Categories} validate={required()} />
            <TextInput source="Author" label="作者" />
            <TextInput source="Source" label="来源" />
            <SelectInput source="Status" label="状态" choices={StatusChoices} />
            <BooleanInput source="IsFeatured" label="推荐" />
            <DateInput source="PublishTime" label="发布时间" />
        </SimpleForm>
    </Edit>
);

export const AgriTechArticleCreate = props => (
    <Create {...props} title="创建农技文章">
        <SimpleForm>
            <TextInput source="Title" label="标题" validate={required()} />
            <RichTextInputInput source="Content" label="内容" />
            <UpLoadFile source="CoverImage" label="封面图片" />
            <TextInput source="Summary" label="摘要" multiline rows={3} />
            <SelectInput source="Category" label="分类" choices={Categories} validate={required()} />
            <TextInput source="Author" label="作者" />
            <TextInput source="Source" label="来源" />
            <SelectInput source="Status" label="状态" initialValue={1} choices={StatusChoices} />
            <BooleanInput source="IsFeatured" label="推荐" initialValue={false} />
            <DateInput source="PublishTime" label="发布时间" />
        </SimpleForm>
    </Create>
);
